<template>
  <div class="type-list">
    <div class="type-item" v-for="(item, index) in data.scoreData" :key="index">
      <div class="t-item-top">
        <div class="t-item-line"></div>
        <div class="t-item-title">{{ item.title }}</div>
        <div class="t-item-score">{{ item.score }}分</div>
        <div class="rules" @click="previewRules(item.val, item.title)"
          >评分规则</div
        >
      </div>
      <div class="t-item-bottom">
        <div class="s-list">
          <div
            class="s-item"
            v-for="(sitem, sindex) in item.list"
            :key="sindex"
          >
            <div class="s-item-title">{{ sitem.name }}</div>
            <div
              class="s-select-list"
              :class="{ 's-select-list-active': sitem.disabled }"
            >
              <div
                class="select-item"
                @click="bindClick(item.list, sitem, selectindex)"
                :style="{ width: selectWidth + 'vw' }"
                v-for="(selectitem, selectindex) in sitem.select"
                :key="selectindex"
              >
                {{ selectitem.text }}
              </div>
              <div
                class="select-item-active"
                :style="{
                  width: selectWidth + 'vw',
                  left: sitem.index * selectWidth + selectWidth / 2 + 'vw'
                }"
                v-show="sitem.index >= 0"
              >
                {{ (sitem.index >= 0 && sitem.select[sitem.index].text) || '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay
      :show="showRules"
      @click="showRules = false"
      :lock-scroll="false"
      :z-index="2002"
    >
      <ReviewRules
        v-model="showRules"
        :data="rulesData"
        :title="rulesTitle"
      ></ReviewRules>
    </van-overlay>
  </div>
</template>
<script>
import ReviewRules from './rules/rules.vue'
import { rulesData } from './rules/data'
export default {
  components: {
    ReviewRules
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rulesData: [],
      rulesTitle: '',
      showRules: false,
      selectTotalWidth: 303,
      selectNum: 4
    }
  },
  computed: {
    selectWidth() {
      return (this.selectTotalWidth / this.selectNum / 375) * 100
    }
  },
  created() {
    this.init()
  },
  methods: {
    previewRules(type, title) {
      ;(this.rulesData = rulesData[type]), (this.rulesTitle = title)
      this.showRules = true
    },
    bindClick(list, item, index) {
      if (item.index == index || item.disabled) {
        return
      }
      console.log('点击')
      if (item.select[index].disabledOther) {
        //如果点击的是禁用其他选项的按钮则先将当前打分全部清空
        list.map((item1, index1) => {
          item1.index = -1
          item1.disabled = true
        })
      } else {
        //如果当前选择的没有禁用，则把之前禁用的选择设置默认未第一个选项
        list.map((item1, index1) => {
          if (item1.index == -1) {
            item1.index = 0
            item1.disabled = false
          }
        })
      }
      //将当前选择的选项设置为正确的选项
      item.index = index
      //将当前选择的选项设置为非禁用
      item.disabled = false
      this.$parent.scoreUpdate = true
      this.computedScore(this.data.scoreData)
    },
    init() {},
    //计算分数
    computedScore(data) {
      data.map((item, index) => {
        let score = item.maxScore
        item.list.map((item1, index1) => {
          if (item1.index >= 0) {
            score += item1.select[item1.index].less
          }
        })
        item.score = score
      })
      return data
    }
  }
}
</script>
<style lang="scss" scoped>
.type-list {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px 0px;
  .type-item {
    .t-item-top {
      display: flex;
      align-items: center;
      margin-bottom: 14px;
      .t-item-line {
        width: 3px;
        height: 16px;
        background: #6236ff;
        margin-right: 12px;
      }
      .t-item-title {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 25px;
        margin-right: 17px;
      }
      .t-item-score {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #6236ff;
        line-height: 25px;
      }
      .rules {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.8);
        line-height: 17px;
        margin-right: 16px;
      }
    }
    .t-item-bottom {
      padding: 0px 16px;
      box-sizing: border-box;
      .s-list {
        .s-item {
          margin-bottom: 14px;
          .s-item-title {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: rgba(0, 0, 0, 0.8);
            line-height: 17px;
            margin-bottom: 10px;
          }
          .s-select-list {
            position: relative;
            display: inline-flex;
            align-items: center;
            height: 24px;
            background: rgba(0, 0, 0, 0.05);
            border-radius: 12px;
            .select-item {
              text-align: center;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 17px;
            }
            .select-item-active {
              position: absolute;
              height: 32px;
              line-height: 32px;
              background: #ffffff;
              box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.05);
              border-radius: 16px;
              box-sizing: border-box;
              border: 1px solid #e2e2e2;
              left: 0%;
              top: 50%;
              text-align: center;
              transform: translate(-50%, -50%);
              transition: left 0.1s ease;
            }
          }
          .s-select-list-active {
            background: #f9f9f9;
            .select-item {
              color: rgba(0, 0, 0, 0.3);
            }
          }
        }
      }
    }
  }
}
</style>
